import * as React from 'react';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import EnterprisePageTemplateWrapper from 'bundles/unified-common/pageUtils/EnterprisePageTemplateWrapper';
import EnterpriseHomeRedirectsWrapper from 'bundles/unified-home-common/pages/enterprise/EnterpriseHomeRedirectsWrapper';
import EnterprisePageTrackingWrapper from 'bundles/unified-home-common/pages/enterprise/EnterprisePageTrackingWrapper';
import EnterpriseHomePageRootContent from 'bundles/unified-home-common/pages/enterprise/home/EnterpriseHomePageRootContent';
import EnterpriseHomePageProvider from 'bundles/unified-home-common/providers/enterprise/pages/EnterpriseHomePageProvider';

const EnterpriseHomePageRoot = () => {
  const enableEnterpriseHomeRefresh = GrowthDiscoveryEpicClient.preview('enableEnterpriseHomeRefresh');
  return (
    <EnterpriseHomePageProvider>
      <EnterprisePageTemplateWrapper hideFooterTopBanner={enableEnterpriseHomeRefresh}>
        <EnterprisePageTrackingWrapper>
          <EnterpriseHomeRedirectsWrapper>
            <EnterpriseHomePageRootContent />
          </EnterpriseHomeRedirectsWrapper>
        </EnterprisePageTrackingWrapper>
      </EnterprisePageTemplateWrapper>
    </EnterpriseHomePageProvider>
  );
};

export default EnterpriseHomePageRoot;
